 
    // ── Countdown timer ──
    function updateCountdown() {
      const now = new Date();
      const end = new Date();
      end.setHours(23, 59, 59, 999);
      const diff = end - now;
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const fmt = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      document.querySelectorAll('#countdown, #countdown2').forEach(el => el.textContent = fmt);
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);

    // ── Image gallery ──
    const images = [
      'https://d2xsxph8kpxj0f.cloudfront.net/310519663220563506/7GbPGeH8GvCcFMKEw5S8dh/product-overview_4ed97225.jpeg',
      'https://d2xsxph8kpxj0f.cloudfront.net/310519663220563506/7GbPGeH8GvCcFMKEw5S8dh/product-closeup_07d37a0a.jpeg',
      'https://d2xsxph8kpxj0f.cloudfront.net/310519663220563506/7GbPGeH8GvCcFMKEw5S8dh/product-lifestyle_a0486325.jpg',
      'https://d2xsxph8kpxj0f.cloudfront.net/310519663220563506/7GbPGeH8GvCcFMKEw5S8dh/product-3in1_f598c325.jpeg',
      'https://d2xsxph8kpxj0f.cloudfront.net/310519663220563506/7GbPGeH8GvCcFMKEw5S8dh/product-redlight_49823f17.jpg',
      'https://d2xsxph8kpxj0f.cloudfront.net/310519663220563506/7GbPGeH8GvCcFMKEw5S8dh/product-scalp_737cebd8.jpg'
    ];
    function selectImage(index, el) {
      document.getElementById('main-img').src = images[index];
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      el.classList.add('active');
      document.getElementById('discount-badge').style.display = index === 0 ? 'block' : 'none';
    }

    // ── Quantity ──
    // let qty = 1;
    const addOnPrice = 19.99;
    let addOnSelected = false;
    // function changeQty(delta) {
    //   qty = Math.max(1, qty + delta);
    //   document.getElementById('qty-display').textContent = qty;
    //   updateATCPrice();
    // }
    // function updateATCPrice() {
    //   const total = (89.99 * qty + (addOnSelected ? addOnPrice : 0)).toFixed(2);
    //   const atcText = document.getElementById('atc-text');
    //   if (atcText && !atcText.textContent.includes('Added')) {
    //     atcText.textContent = `Add to Cart — $${total}`;
    //   }
    // }

    // ── Add to cart ──
    const cartTimers = {};
    // function addToCart(btnId) {
    //   const btn = document.getElementById(btnId);
    //   if (!btn) return;
    //   btn.classList.add('added');
    //   if (btnId === 'atc-btn') {
    //     document.getElementById('atc-text').textContent = '✓ Added to Cart!';
    //     document.getElementById('sticky-btn').classList.add('added');
    //     document.getElementById('sticky-btn').textContent = '✓ Added!';
    //   } else if (btnId === 'sticky-btn') {
    //     btn.textContent = '✓ Added!';
    //   } else {
    //     btn.textContent = '✓ Added to Cart!';
    //   }
    //   clearTimeout(cartTimers[btnId]);
    //   cartTimers[btnId] = setTimeout(() => {
    //     btn.classList.remove('added');
    //     if (btnId === 'atc-btn') {
    //       updateATCPrice();
    //       const stickyBtn = document.getElementById('sticky-btn');
    //       stickyBtn.classList.remove('added');
    //       stickyBtn.textContent = 'Add to Cart';
    //     } else if (btnId === 'sticky-btn') {
    //       btn.textContent = 'Add to Cart';
    //     } else {
    //       const labels = {
    //         'compare-btn': 'Get LumiGlide™ — $89.99',
    //         'reviews-btn': 'Join 2,847 Happy Customers — $89.99',
    //         'final-btn': 'Add to Cart — $89.99'
    //       };
    //       btn.textContent = labels[btnId] || 'Add to Cart — $89.99';
    //     }
    //   }, 2500);
    // }

  // ── Scroll fade-in ──
  const fadeEls = document.querySelectorAll('.fade-in');     
  const fadeObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '-40px' });
  fadeEls.forEach(el => fadeObserver.observe(el));
 
  function addToCart(btnId) {
    const btn = document.getElementById(btnId);
    if (!btn) return;

    btn.classList.add('added');
    const btnText = btn.querySelector('span');

    // Store original text (important, otherwise you’re guessing later)
    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent;
    }

    // ✅ Set success text
    if (btnId === 'sticky-btn') {
      // btn.textContent = '✓ Added!';
      btnText.textContent = '✓ Added!';
    } else {
      // btn.textContent = '✓ Added to Cart!';
      btnText.textContent = '✓ Added to Cart!';
    }

    clearTimeout(cartTimers[btnId]);

    cartTimers[btnId] = setTimeout(() => {
      btn.classList.remove('added');

      // ✅ Restore original text safely
      // btn.textContent = btn.dataset.originalText;
      btnText.textContent = btn.dataset.originalText;
    }, 2500);
  }

  function handleAddToCart(buttonId) {

    const comCheck = document.getElementById('addon-box');
    const compInput = document.getElementById('addon-variant-input');
    const compInputProp = document.getElementById('addon-variant-input-hidden');

    if (comCheck && comCheck.classList.contains('selected')) {
      comCheck.classList.remove('selected')
      compInput.setAttribute('disabled', true);
      compInput.value = '';
      compInputProp.setAttribute('disabled', true);
      compInputProp.value = '';
    }
    
    const btn = document.getElementById(buttonId);
    const btnText = btn.querySelector('span');
    if (!btn) return;

    const loader = btn.querySelector('.loading__spinner');

    btn.disabled = true;
    btnText.style.opacity = '0';
    loader?.classList.remove('hidden');

    const variantId = btn.dataset.variantid;
    const addonId = document.getElementById('addon-variant-input')?.value;
    const propValue = btn.dataset.prop;
    const properties = {};
    properties[`${propValue}`] = "true"; 

    addToCartCore({
      variantId,
      quantity: 1,
      addonId,
      properties
    })
    .then(response => {
      const cartDrawer = document.querySelector("cart-drawer");

      btnText.style.opacity = '1';  
      loader?.classList.add('hidden');
      btn.disabled = false;

      // ✅ Use your UI handler here
      addToCart(buttonId);

      setTimeout(() => {
        cartDrawer?.renderContents?.(response);
        // cartDrawer?.open?.();
        cartDrawer?.classList.remove("is-empty");
      }, 300);
    })
    .catch(err => {
      console.error(err);
      loader?.classList.add('hidden');
      btn.disabled = false;
    });

  }

  function addToCartCore({ variantId, quantity = 1, addonId = null, properties = {}  }) {
    if (!variantId) {
      console.error("Missing variantId");
      return;
    }

    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;

    const sectionsToRender = cartDrawer.getSectionsToRender().map(s => s.id);

    const items = [
      { id: variantId, quantity, properties }
    ];

    if (addonId) {
      items.push({ id: addonId, quantity: 1 , properties });
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items,
        sections: sectionsToRender,
        sections_url: window.location.pathname,
      }),
    }).then(res => res.json());
  }

// sticky 
const buyBox = document.querySelector('.product__info-container');
const stickyBar = document.getElementById('sticky-bar');
const footer = document.querySelector('.shopify-section-group-footer-group-new');

if (buyBox && stickyBar) {
  const observer = new IntersectionObserver(([entry]) => {
    stickyBar.classList.toggle('visible', !entry.isIntersecting);
  }, { threshold: 0 });

  observer.observe(buyBox);

    const updateFooterSpacing = () => {
      const height = stickyBar.offsetHeight;
      footer.style.marginBottom = height + 'px';
    };

    updateFooterSpacing();
    window.addEventListener('resize', updateFooterSpacing);
}

function generateId() {
  return Date.now() + Math.floor(Math.random() * 1000);
}

document.querySelectorAll('.atc-parent').forEach(wrapper => {
  const id = generateId();

  if (wrapper) {
    wrapper.dataset.prop = `_parent-${id}`;
  }

});

// cart drawer add - remove
// ADD TO CART (UPDATED)
function addToCartJS(qty, variantId, sellingPlanId = null, propKey = null) {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  const sectionsToRender = cartDrawer
    .getSectionsToRender()
    .map(section => section.id);

  let bodyData = {
    quantity: qty,
    id: variantId,
    selling_plan: sellingPlanId,
    sections: sectionsToRender,
    sections_url: window.location.pathname,
  };

  // ✅ attach parent/child property
  if (propKey) {
    bodyData.properties = {
      [propKey]: "true"
    };
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bodyData),
  })
    .then(res => res.json())
    .then(response => {
      cartDrawer.renderContents(response);
      const loader = document.getElementById('cart-loader');
      if (loader) loader.style.display = 'none';
      cartDrawer.open();

      if (cartDrawer.classList.contains("is-empty")) {
        cartDrawer.classList.remove("is-empty");
      }
    })
    .catch(err => console.error("Add to cart error:", err));
}

// REMOVE FROM CART
function removeFromCartJS(lineItemKey) {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  const sectionsToRender = cartDrawer
    .getSectionsToRender()
    .map(section => section.id);

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: lineItemKey, // ✅ MUST be item.key
      quantity: 0,
      sections: sectionsToRender,
      sections_url: window.location.pathname,
    }),
  })
    .then(res => res.json())
    .then(response => {
      cartDrawer.renderContents(response);
      const loader = document.getElementById('cart-loader');
      if (loader) loader.style.display = 'none';
      cartDrawer.open();

      if (cartDrawer.classList.contains("is-empty")) {
        cartDrawer.classList.remove("is-empty");
      }
    })
    .catch(err => console.error("Remove error:", err));
}

// FIND CHILD BY PROPERTY
async function removeChildByProp(propKey) {
  const cart = await fetch("/cart.js").then(res => res.json());

  // 🔍 find correct line item
  const item = cart.items.find(item =>
    item.properties &&
    Object.keys(item.properties).includes(propKey)
  );

  if (!item) {
    console.warn("Child not found for:", propKey);
    return;
  }

  // ✅ NOW you have the key
  const lineItemKey = item.key;

  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  const sectionsToRender = cartDrawer
    .getSectionsToRender()
    .map(section => section.id);

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: lineItemKey, // ✅ correct key
      quantity: 0,
      sections: sectionsToRender,
      sections_url: window.location.pathname,
    }),
  })
    .then(res => res.json())
    .then(response => {
      cartDrawer.renderContents(response);
      cartDrawer.open();
    })
    .catch(err => console.error("Remove error:", err));
}

// TOGGLE ADDON (MAIN FUNCTION)
function toggleCartAddon(el) {
  const loader = document.getElementById('cart-loader');
  if (loader) loader.style.display = 'flex';

  const wrapper = el.closest(".cart-addon-bump");
  const wrapperCheck = el.querySelector(".cart-addon-cb");

  const variantId = wrapper.dataset.addonVariantId;
  const propKey = wrapper.dataset.prop;
  // console.log(propKey,"propKey---");
  const isChecked = el.classList.contains("selected");

  el.classList.toggle("selected");
  wrapperCheck.classList.toggle("checked");
  wrapperCheck.textContent = wrapperCheck.classList.contains("checked") ? "✓" : " ";

  if (!isChecked) {
    // ➕ ADD
    addToCartJS(1, variantId, null, propKey);
  } else {
    // ➖ REMOVE
    removeChildByProp(propKey); // ✅ now works
  }
}

// AUTO-BIND CLICK EVENTS
document.addEventListener("click", function(e) {
  const cb = e.target.closest(".cart-addon-cb");
  if (cb) {
    toggleCartAddon(cb);
  }
});

